import React, { useState, useEffect } from 'react';
import Start from './components/Start';
import Question from './components/Question';
import End from './components/End';
import Modal from './components/Modal';
import fire from '../fire';
import * as Survey from 'survey-react'
import QuestionJson from './data/QuestionJson';
import 'survey-react/survey.css'
//let interval;

const Quiz = (props) => {

  return(
    <div className="container">
    <Survey.Survey
    json={QuestionJson}
    onComplete={async (data) => {
      await fire.firestore().collection("selection").add(data.valuesHash).then(() => {
        //  fire.firestore().collection("users").doc(props.User).update({
        //   quizaccess:false,
        // })
      }
      )

    }}
    />
    </div>
  )
  /*const [step, setStep] = useState(1);
  const [activeQuestion, setActiveQuestion] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [time, setTime] = useState(0);
  const [quizData, setquizData] = useState("")

  useEffect(() => {
    fire.firestore().collection("spot-test").doc("quiz").onSnapshot((snapshot) => {
      setquizData(snapshot.data())
    })

    if(step === 3) {
      clearInterval(interval);
    }
  }, [step]);

  

  const quizStartHandler = () => {
    setStep(2);
    interval = setInterval(() => {
      setTime(prevTime => prevTime + 1);
    }, 1000);
  }

  const resetClickHandler = () => {
    setActiveQuestion(0);
    setAnswers([]);
    setStep(2);
    setTime(0);
    interval = setInterval(() => {
      setTime(prevTime => prevTime + 1);
    }, 1000);
  }

  return (
    <div className="quiz">
      {step === 1 && <Start onQuizStart={quizStartHandler} />}
      {step === 2 && <Question 
        data={quizData.data[activeQuestion]}
        onAnswerUpdate={setAnswers}
        numberOfQuestions={quizData.data.length}
        activeQuestion={activeQuestion}
        onSetActiveQuestion={setActiveQuestion}
        onSetStep={setStep}
        qtTimer={props.qtTimer}
        palayn={props.palayn}
      />}
      {step === 3 && <End 
        User={props.User}
        results={answers}
        data={quizData.data}
        onReset={resetClickHandler}
        onAnswersCheck={() => setShowModal(true)}
        time={time}
        palayn={props.palayn}
      />}

      {showModal && <Modal 
        onClose={() => setShowModal(false)}
        results={answers}
        data={quizData.data}
      />}
    </div>
  );*/
}

export default Quiz;